import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from '@stripe/react-stripe-js';
import {
  StripeCardCvcElementChangeEvent,
  StripeCardExpiryElementChangeEvent,
  StripeCardNumberElementChangeEvent,
} from '@stripe/stripe-js';
import cn from 'classnames';

import styles from './InputCard.module.scss';

type InputCardProps = {
  handleCardNumberChange: (event: StripeCardNumberElementChangeEvent) => void;
  setName: (name: string) => void;
  name: string;
  handleCardExpiryChange: (event: StripeCardExpiryElementChangeEvent) => void;
  handleCardCvcChange: (event: StripeCardCvcElementChangeEvent) => void;
};

const InputCard = ({
  handleCardNumberChange,
  setName,
  name,
  handleCardExpiryChange,
  handleCardCvcChange,
}: InputCardProps): JSX.Element => {
  return (
    <div className={styles.inputCard}>
      <div className={styles.inputGroup}>
        <label className={styles.label}>カード番号</label>
        <div className={styles.cardInput}>
          <CardNumberElement
            onChange={handleCardNumberChange}
            options={{
              showIcon: true,
              style: {
                base: {
                  fontSize: '14px',
                  color: '#000000',
                  '::placeholder': {
                    color: '#CCCCCC',
                  },
                },
                invalid: {
                  color: '#FA553F',
                },
              },
            }}
          />
        </div>
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.label} htmlFor="cc-name">
          お名前
        </label>
        <input
          type="text"
          id="cc-name"
          name="cc-name"
          placeholder="TARO SUZUKI"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoComplete="cc-name"
        />
      </div>
      <div className={styles.inputGroupWrapper}>
        <div className={cn(styles.inputGroup, styles.expiry)}>
          <label className={styles.label}>有効期限</label>
          <div className={styles.cardInput}>
            <CardExpiryElement
              onChange={handleCardExpiryChange}
              options={{
                style: {
                  base: {
                    fontSize: '14px',
                    color: '#000000',
                    '::placeholder': {
                      color: '#CCCCCC',
                    },
                  },
                  invalid: {
                    color: '#FA553F',
                  },
                },
              }}
            />
          </div>
        </div>
        <div className={cn(styles.inputGroup, styles.cvc)}>
          <label className={styles.label}>コード</label>
          <div className={styles.cardInput}>
            <CardCvcElement
              onChange={handleCardCvcChange}
              options={{
                style: {
                  base: {
                    fontSize: '14px',
                    color: '#000000',
                    '::placeholder': {
                      color: '#CCCCCC',
                    },
                  },
                  invalid: {
                    color: '#FA553F',
                  },
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InputCard;
